import React, { useContext, useState } from 'react'
import { MoreVertical } from 'react-feather'
import { CardBody, Input, Label } from 'reactstrap'
import { Dropdowns } from '../../../AbstractElements'
import CommonModal from '../../UiKits/Modals/common/modal'
import { showAlert } from '../../../utils/alert';
import { toast } from 'react-toastify'
import { firebaseFunction } from '../../../firebase/init'
import { deleteDoc } from '../../../firebase/utils'
import AdminContext from '../../../Helper/admin'

const AdminAction = ({ data, open, setOpen, getAdmins, setAdmins, admins }) => {
  const [admin, setAdmin] = useState({
    fullName: "",
    email: "",
    password: "",
    isAdmin: true,
  });
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false)
  const { setAdminRoles, adminRoles } = useContext(AdminContext);

  const onChangeHandler = ({ target }) => {
    setAdmin({ ...admin, [target.name]: target.value });
  };


  const deleteAdmin = async () => {
    try {
      const warningText = `Are you sure you want to delete ${data?.fullName} account?`
      const isConfirm = await showAlert(warningText, 'Delete')
      if (isConfirm) {
        await deleteDoc('users', data.email)
        let deleteAdminApi = firebaseFunction.httpsCallable("deleteUser");
        await deleteAdminApi({
          uid: data.uid,
        });
        setAdmins(admins.filter((admin) => admin.uid !== data.uid));
        setAdminRoles(adminRoles.filter((admin) => admin.uid !== data.uid));
        toast.success("Admin deleted sucessfully");
      }
    } catch (error) {
      console.log(error);
    }
  }

  const changePassword = async () => {
    try {
      let passwordChangeApi = firebaseFunction.httpsCallable("changePassword");
      await passwordChangeApi({
        newPassword: admin.password.trim(),
        uid: data.uid,
      });
      setTimeout(() => {
        toast.success("Password changed sucessfully");
        setAdmin({ ...admin, password: "" });
        setShow(false);
      }, 2000);
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    }
  }

  const createAdmin = async () => {
    if (loading) return
    try {
      const { email, isAdmin, fullName, password } = admin;
      if (!email.trim() || !fullName.trim() || !password.trim()) {
        toast.error("Please fill up all details");
        return;
      }
      if (password.length < 6) {
        toast.error("Password must be greater than 6 characters");
        return;
      }
      setLoading(true);
      let createUserApi = firebaseFunction.httpsCallable('createUser')
      await createUserApi({
        email: admin.email.toLowerCase(),
        isAdmin: true,
        fullName: admin.fullName,
        password: admin.password,
      });
      toast.success("Admin created Successfully");
      setAdmin({ email: "", fullName: "", password: "" });
      setAdminRoles([...adminRoles, admin])
      setLoading(false)
      setOpen(false)
      getAdmins();
    } catch (error) {
      console.log("error", error);
      toast.error(error.message);
      setLoading(false);
    }
  }

  const actionOptions = [
    {
      item: 'Change Password',
      onClick: () => setShow(true)
    },
    {
      item: 'Delete Account',
      onClick: () => deleteAdmin()
    }
  ]

  return (
    <div>
      <CardBody className="dropdown-basic p-0 fee-table-action d-flex align-items-center justify-content-center">
        <Dropdowns
          attrDropBtn={{ className: 'dropbtn table-action' }}
          attrDropMenu={{ className: 'dropdown-content module-dropdown' }}
          dropItem={actionOptions}
          dropBtnContent={<MoreVertical className="dropbtn" />}
          attrDropItem={{
            toggle: false,
          }}
        />
      </CardBody>
      <CommonModal
        isOpen={open}
        toggler={() => setOpen(false)}
        successText={loading ? 'loading...' : 'Create'}
        title='Create Admin'
        success={() => createAdmin()}
        size="lg">
        <div>
          <Label htmlFor='fullName' className='f-w-500'>Full Name</Label>
          <Input id='fullName' name='fullName' value={admin.fullName} onChange={onChangeHandler} />
        </div>
        <div className='m-t-10'>
          <Label htmlFor='email' className='f-w-500'>Email</Label>
          <Input id='email' name='email' value={admin.email} onChange={onChangeHandler} />
        </div>
        <div className='m-t-10'>
          <Label htmlFor='password' className='f-w-500'>Password</Label>
          <Input id='password' name='password' value={admin.password} onChange={onChangeHandler} />
        </div>
      </CommonModal>
      <CommonModal
        isOpen={show}
        toggler={() => setShow(false)}
        successText={'Change'}
        title='Change Password'
        success={() => changePassword()}
        size="md">
        <div>
          <Label htmlFor='password' className='f-w-500'>New Password</Label>
          <Input id='password' name='password' value={admin.password} onChange={onChangeHandler} />
        </div>

      </CommonModal>
    </div>
  )
}

export default AdminAction